//@ts-nocheck
import { getType } from "../helpers";
export function createSymbolInfo(ScripInfoData, symbolInfoName, symbolName, Marketsession_time, Market_holiday_correction, Market_holiday_session) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone === "Asia/Calcutta"
        ? "Asia/Kolkata"
        : Intl.DateTimeFormat().resolvedOptions().timeZone;
    const symbolInfo = {
        name: ScripInfoData === null || ScripInfoData === void 0 ? void 0 : ScripInfoData.Name,
        ticker: symbolInfoName +
            "/" +
            (ScripInfoData === null || ScripInfoData === void 0 ? void 0 : ScripInfoData.ScripCode) +
            "-" +
            (ScripInfoData === null || ScripInfoData === void 0 ? void 0 : ScripInfoData.ExchType),
        description: ScripInfoData === null || ScripInfoData === void 0 ? void 0 : ScripInfoData.Name,
        session: Marketsession_time,
        corrections: Market_holiday_correction,
        session_holidays: Market_holiday_session,
        timezone: timezone,
        interval: "D",
        exchange: symbolName.substring(0, symbolName.indexOf(":")),
        minmov: 1,
        pricescale: getType(ScripInfoData === null || ScripInfoData === void 0 ? void 0 : ScripInfoData.InstrumentType, ScripInfoData === null || ScripInfoData === void 0 ? void 0 : ScripInfoData.ExchType),
        has_intraday: true,
        intraday_multipliers: ["1", "30"],
        has_daily: true,
        daily_multipliers: ["1"],
        visible_plots_set: "ohlcv",
        listed_exchange: symbolName.substring(0, 3),
        has_weekly_and_monthly: false,
        locale: "in",
        volume_precision: 2,
        data_status: "streaming",
        scripCode: ScripInfoData === null || ScripInfoData === void 0 ? void 0 : ScripInfoData.ScripCode,
        exchType: ScripInfoData === null || ScripInfoData === void 0 ? void 0 : ScripInfoData.ExchType,
        type: ScripInfoData === null || ScripInfoData === void 0 ? void 0 : ScripInfoData.InstrumentType,
    };
    return symbolInfo;
}
